import { CircularProgress, Stack } from "@mui/material";

export default function Loader(){

    return <Stack direction='row' justifyContent='center' alignItems='center' sx={{p: 3}}>
        <CircularProgress />
    </Stack>
}